module.exports = __webpack_public_path__ + "img/IconUser.56127f68.svg";